// Use environment variable for API URL, with fallback to relative path (works with Apache proxy) or localhost for development
const getApiUrl = () => {
  // If REACT_APP_API_URL is explicitly set, use it
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // In production or when building for production, use relative path which works with Apache proxy
  // This allows the same build to work on both localhost and deployed server
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }
  
  // In development, default to localhost:5004
  return 'http://localhost:5004/api';
};

const getBaseUrl = () => {
  // If REACT_APP_BASE_URL is explicitly set, use it
  if (process.env.REACT_APP_BASE_URL) {
    return process.env.REACT_APP_BASE_URL;
  }
  
  // In production, use empty string (relative path)
  if (process.env.NODE_ENV === 'production') {
    return '';
  }
  
  // In development, default to localhost:5004
  return 'http://localhost:5004';
};

export const API_URL = getApiUrl();
export const BASE_URL = getBaseUrl();

export const USER_ROLES = {
  USER: 'user',
  VENUE: 'venue',
  ARTIST: 'artist',
  ADMIN: 'admin',
  DISABLED: 'disabled'
};

export const EVENT_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  CANCELLED: 'cancelled'
};

export const VENUE_STYLESHEETS = {
  DEFAULT: 'default',
  WHITE: 'white',
  DARK: 'dark',
  LUXURY: 'luxury',
  ALDER: 'alder',
  SPEAKEASY: 'speakeasy'
}; 